import { ViewModel, View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { SelectRecursive, stringIsNullOrEmpty, translate } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ProductGroupDefinitionView } from "./productGroupDefinition-view"

export class ProductGroupDefinitionViewModel extends WindowViewModel implements IProductGroupContainer {
    public getTitle(): string {
        return "تعریف گروه بندی کالا";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.groups = ObservableArray.create<productGroup>();
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new ProductGroupDefinitionView();
    }
    public getTypeId(): string {
        return "VM-9C2EEEA4-6007-4A8F-8333-57F223EF71DE"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set groups(v: ObservableArray<productGroup>) { this._groups = v; } public get groups(): ObservableArray<productGroup> { return this._groups; } private _groups: ObservableArray<productGroup>;

    async refresh() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ProductGroupManagement/GetAllProductGroups', {});
            let groups = SelectRecursive<any, productGroup>(this, result.Groups, x => x.Children, (x, parent) => {
                let result: productGroup = new productGroup(parent, parent);
                result.id = x.Id;
                result.name = x.Name;
                result.prefix = x.PrefixCode;
                result.productCodeLength = x.ProductCodeLength;
                result.productCount = x.ProductCount;
                result.canEdit = x.ProductCount == 0;
                result.canRemove = false;
                return result;
            }, (x, y) => x.children.update(...y));
            this.groups.update(...groups);
            this.groups.forEach(q => q.updatePrefixPath());
            this.groups.forEach(q => q.updateAllowSettingProductCodeLength());
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async save() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ProductGroupManagement/SynchroniseProductGroups', {
                Groups: SelectRecursive(null, this.groups, x => x.children, (x, y) => {
                    return {
                        Id: x.id,
                        Name: x.name,
                        PrefixCode: x.prefix,
                        ProductCodeLength: x.canSetProductCodeLength == true ? x.productCodeLength : null,
                        Children: []
                    };
                }, (x, y) => x.Children = y)
            });
            if (result.IsSuccessful) {
                this.refresh();
                await this.messageBoxConfirmSuccess("گروه کالا با موفقیت ثبت شد", "تعریف گروه کالا");
            } else {
                await this.messageBoxConfirmWarning("مشکلی در ثبت گروه کالا وجود دارد", "تعریف گروه کالا");
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning("مشکلی در ثبت گروه کالا وجود دارد", "تعریف گروه کالا");
        } finally {
            this.isLoading = false;
        }
    }

    removeChild(productGroup: productGroup) {
        this.groups.remove(productGroup);
    }
    addChild() {
        let newChild = new productGroup(this, this);
        this.groups.push(newChild);
    }
    getPrefixPath(): string {
        return '';
    }

}

export class productGroup extends ViewModel implements IProductGroupContainer {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel, parentContainer: IProductGroupContainer) {
        super(parent);
        this.children = ObservableArray.create<productGroup>();
        this.parentGroup = parentContainer;
        this.canRemove = true;
        this.canEdit = true;
        this.canSetProductCodeLength = true;
        this.prefix = '';
        this.productCount = 0;
    }


    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set prefix(v: string) {
        this._prefix = v;
        this.updatePrefixPath();
    } public get prefix(): string { return this._prefix; } private _prefix: string;
    public set prefixPath(v: string) { this._prefixPath = v; } public get prefixPath(): string { return this._prefixPath; } private _prefixPath: string;
    public set productCodeLength(v: number) { this._productCodeLength = getAsNumber(v, true); } public get productCodeLength(): number { return this._productCodeLength; } private _productCodeLength: number;
    public set children(v: ObservableArray<productGroup>) { this._children = v; } public get children(): ObservableArray<productGroup> { return this._children; } private _children: ObservableArray<productGroup>;
    public set parentGroup(v: IProductGroupContainer) { this._parentGroup = v; } public get parentGroup(): IProductGroupContainer { return this._parentGroup; } private _parentGroup: IProductGroupContainer;
    public set canRemove(v: boolean) { this._canRemove = v; } public get canRemove(): boolean { return this._canRemove; } private _canRemove: boolean;
    public set canSetProductCodeLength(v: boolean) { this._canSetProductCodeLength = v; } public get canSetProductCodeLength(): boolean { return this._canSetProductCodeLength; } private _canSetProductCodeLength: boolean;
    public set productCount(v: number) { this._productCount = v; } public get productCount(): number { return this._productCount;} private _productCount: number;
    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit;} private _canEdit: boolean;

    addChild() {
        let newChild = new productGroup(this, this);
        this.children.push(newChild);
        this.canSetProductCodeLength = false;
    }
    getPrefixPath(): string {
        return this.prefixPath;
    }
    remove() {
        if (stringIsNullOrEmpty(this.id)) {
            this.parentGroup.removeChild(this);
        }
    }

    removeChild(productGroup) {
        this.children.remove(productGroup);
        if (this.children.length == 0) {
            this.canSetProductCodeLength = true;
        }
    }

    updatePrefixPath(): void {
        this.prefixPath = `${this.parentGroup.getPrefixPath()}${this.prefix}`;
        this.children.forEach(q => q.updatePrefixPath());
    }
    updateAllowSettingProductCodeLength(): void {
        if (this.children.length == 0)
            this.canSetProductCodeLength = true;
        else {
            this.canSetProductCodeLength = false;
            this.children.forEach(q => q.updateAllowSettingProductCodeLength());
        }
    }

}

interface IProductGroupContainer {
    removeChild(productGroup: productGroup);
    getPrefixPath(): string;
}
